import { Flex, SimpleGrid, Skeleton, Image, VStack } from "@chakra-ui/react"
import { Asset } from "@hydrologiq/gql-experience/graphql"
import Map, { LocationMarker } from "@hydrologiq/shared/asset/location/map/Map"
import { mapsApiKey } from "@hydrologiq/assets/config"
import Informative from "@hydrologiq/shared/Informative"
import { SectionHeading } from "@hydrologiq/shared/chakra/custom/Section"
import { useCopyValues } from "@hydrologiq/shared/providers/helpers/useCopy"
import { DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"
import { COPY_KEYS } from "@hydrologiq/shared/copy/constants"
import { useEffect, useState } from "react"
export default function AssetActions({ asset }: { asset?: Asset }) {

  const [focusMarker, setFocusMarker] = useState<LocationMarker | undefined>(undefined)
  useEffect(() => {
    if (asset?.current_location) {
      setFocusMarker({
        location: {
          lat: asset?.current_location.lat ?? 0,
          long: asset?.current_location.long ?? 0,
        },
        title: "Current Location",
      })
    }
  }, [asset])


  console.log(focusMarker)

  const copy = useCopyValues({
    [COPY_KEYS.HEADINGS.ASSET]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.ASSET],
  })

  const height = { base: "150px", sm: "350px" }

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} gap={5} minHeight={"400px"} height={"100%"} width={"100%"}>
      <VStack alignItems={"start"} height={"100%"} width={"100%"}>
        <SectionHeading>{copy[COPY_KEYS.HEADINGS.ASSET]} image</SectionHeading>
        {!asset ? (
          <Skeleton height={height} width={"100%"} />
        ) : asset.image_url ? (
          <Image width={"100%"} fit={"fill"} src={asset.image_url} />
        ) : (
          <Flex justifyContent={"center"} alignItems={"center"} height={height} width={"100%"}>
            <Informative heading={`Please upload an image of the ${copy[COPY_KEYS.HEADINGS.ASSET].toLowerCase()}`} />
          </Flex>
        )}
      </VStack>
      <VStack alignItems={"start"} height={"100%"} width={"100%"}>
        <SectionHeading>Current Location</SectionHeading>
        {!asset ? (
          <Skeleton height={height} width={"100%"} />
        ) : asset.current_location ? (
          <Map
            width={"100%"}
            height={{ base: "350px", md: "100%" }}
            focusMarker={focusMarker}
            apiKey={mapsApiKey}
            zoom={13}
            paddingBottom={0}
            key={`${asset?.id}-${asset?.current_location?.lat}-${asset?.current_location?.long}`}
          />
        ) : (
          <Flex justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Informative heading="No location data" />
          </Flex>
        )}
      </VStack>
    </SimpleGrid>
  )
}
